import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { HttpEvent, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

interface CacheValue {
  expiry: number;
  value: HttpResponse<any>;
}

@Injectable()
export class HttpCachingService {
  private cacheMap = new Map<string, CacheValue>(null);
  private readonly maxAge: number = 600000;

  get(req: HttpRequest<any>): HttpResponse<any> {
    const key = this.toKey(req);
    const cachedData = this.cacheMap.get(key);
    if (cachedData && cachedData.expiry > Date.now()) {
      return cachedData.value;
    }
    this.cacheMap.delete(key);
    return null;
  }

  set(req: HttpRequest<any>, next: HttpHandler, maxAge = this.maxAge): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(value => {
        if (value instanceof HttpResponse) {
          this.cacheMap.set(this.toKey(req), { expiry: Date.now() + maxAge, value });
        }
      })
    );
  }

  private toKey(req: HttpRequest<any>): string {
    return `${req.urlWithParams}-${JSON.stringify(req.serializeBody())}`;
  }
}
